/* =========================================================
   LLAVE RACHE — JS compartido por las dos landings
   Vanilla, sin dependencias. Idempotente: se puede cargar
   varias veces (una por sección) sin duplicar listeners.
   Cada init va envuelto en try/catch para que un fallo
   aislado no tumbe el resto de la página.
   ========================================================= */
(function () {
  'use strict';
  if (window.__lrInit) return;
  window.__lrInit = true;

  function safe(fn, name) {
    try { fn(); } catch (e) {
      if (window.console && console.warn) console.warn('[lr] fallo en ' + name, e);
    }
  }

  /* --- Reveal al hacer scroll --------------------------------------- */
  function initReveal() {
    var nodes = document.querySelectorAll('.lr-reveal, .lr-stagger');
    if (!nodes.length) return;

    // Sin IntersectionObserver: mostrar todo de una vez.
    if (!('IntersectionObserver' in window)) {
      for (var i = 0; i < nodes.length; i++) nodes[i].classList.add('lr-in');
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) {
          en.target.classList.add('lr-in');
          io.unobserve(en.target);
        }
      });
    }, { threshold: 0.05, rootMargin: '0px 0px -8% 0px' });

    for (var j = 0; j < nodes.length; j++) io.observe(nodes[j]);

    // Red de seguridad: a los 6 s se revela cualquier cosa que siga oculta.
    window.setTimeout(function () {
      var pend = document.querySelectorAll('.lr-reveal:not(.lr-in), .lr-stagger:not(.lr-in)');
      for (var k = 0; k < pend.length; k++) pend[k].classList.add('lr-in');
    }, 6000);
  }

  /* --- FAQ: solo una abierta a la vez ------------------------------- */
  function initFaq() {
    var groups = document.querySelectorAll('.lr-faq');
    for (var g = 0; g < groups.length; g++) {
      (function (group) {
        var items = group.querySelectorAll('details');
        for (var i = 0; i < items.length; i++) {
          items[i].addEventListener('toggle', function () {
            if (!this.open) return;
            for (var j = 0; j < items.length; j++) {
              if (items[j] !== this) items[j].open = false;
            }
          });
        }
      })(groups[g]);
    }
  }

  /* --- Botones que llevan al bloque de compra ----------------------- */
  function initScrollToBuy() {
    document.addEventListener('click', function (ev) {
      var trigger = ev.target.closest ? ev.target.closest('[data-lr-buy]') : null;
      if (!trigger) return;
      var target =
        document.querySelector('.product-form__buttons') ||
        document.querySelector('product-form') ||
        document.querySelector('.shopify-payment-button') ||
        document.querySelector('.product__info-container');
      if (!target) return;
      ev.preventDefault();
      var top = target.getBoundingClientRect().top + window.pageYOffset - 90;
      window.scrollTo({ top: top, behavior: 'smooth' });
    });
  }

  /* --- Barra de compra fija en móvil -------------------------------- */
  function initSticky() {
    var bar = document.querySelector('[data-lr-sticky]');
    if (!bar) return;
    var anchor = document.querySelector('.lr-hero') || document.querySelector('.product__info-container');
    if (!anchor) return;

    function sync() {
      var passed = anchor.getBoundingClientRect().bottom < 0;
      bar.classList.toggle('lr-in', passed);
    }
    window.addEventListener('scroll', sync, { passive: true });
    sync();
  }

  /* --- Video: reproducir solo cuando está a la vista ---------------- */
  function initVideo() {
    var vids = document.querySelectorAll('[data-lr-video]');
    if (!vids.length || !('IntersectionObserver' in window)) return;

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var v = en.target;
        if (en.isIntersecting) {
          var p = v.play();
          if (p && p.catch) p.catch(function () { /* autoplay bloqueado: sin ruido */ });
        } else {
          v.pause();
        }
      });
    }, { threshold: 0.35 });

    for (var i = 0; i < vids.length; i++) io.observe(vids[i]);
  }

  /* --- Carrusel de testimonios -------------------------------------- */
  function initCarrusel() {
    var cajas = document.querySelectorAll('[data-lr-carrusel]');

    for (var c = 0; c < cajas.length; c++) {
      (function (caja) {
        var track = caja.querySelector('[data-lr-track]');
        var zonaPuntos = caja.querySelector('[data-lr-puntos]');
        if (!track) return;

        var slides = track.children;
        if (slides.length < 2) return;

        var espera = parseInt(caja.getAttribute('data-autoplay'), 10) || 0;
        var timer = null;
        var reanudar = null;

        /* Posición de desplazamiento de cada tarjeta, medida desde la primera */
        function posDe(i) {
          return slides[i].offsetLeft - slides[0].offsetLeft;
        }

        /* Índice de la tarjeta que ocupa el borde izquierdo visible */
        function actual() {
          var pos = track.scrollLeft;
          var mejor = 0, dif = Infinity;
          for (var i = 0; i < slides.length; i++) {
            var d = Math.abs(posDe(i) - pos);
            if (d < dif) { dif = d; mejor = i; }
          }
          return mejor;
        }

        function irA(i) {
          var n = slides.length;
          var idx = ((i % n) + n) % n;
          track.scrollTo({ left: posDe(idx), behavior: 'smooth' });
        }

        /* Puntos de selección manual */
        var puntos = [];
        if (zonaPuntos) {
          for (var i = 0; i < slides.length; i++) {
            (function (idx) {
              var b = document.createElement('button');
              b.type = 'button';
              b.className = 'lr-carrusel__punto';
              b.setAttribute('role', 'tab');
              b.setAttribute('aria-label', 'Testimonio ' + (idx + 1));
              b.addEventListener('click', function () { pausar(); irA(idx); });
              zonaPuntos.appendChild(b);
              puntos.push(b);
            })(i);
          }
        }

        function pintarPuntos() {
          var a = actual();
          for (var i = 0; i < puntos.length; i++) {
            puntos[i].setAttribute('aria-selected', i === a ? 'true' : 'false');
          }
        }

        var prev = caja.querySelector('[data-lr-prev]');
        var next = caja.querySelector('[data-lr-next]');
        if (prev) prev.addEventListener('click', function () { pausar(); irA(actual() - 1); });
        if (next) next.addEventListener('click', function () { pausar(); irA(actual() + 1); });

        /* Autorrotación, que se detiene en cuanto la persona interactúa */
        function arrancar() {
          if (!espera || timer) return;
          timer = window.setInterval(function () { irA(actual() + 1); }, espera);
        }
        function parar() {
          if (timer) { window.clearInterval(timer); timer = null; }
        }
        function pausar() {
          parar();
          if (reanudar) window.clearTimeout(reanudar);
          reanudar = window.setTimeout(arrancar, Math.max(espera, 6000));
        }

        track.addEventListener('scroll', pintarPuntos, { passive: true });
        caja.addEventListener('pointerdown', pausar);
        caja.addEventListener('mouseenter', parar);
        caja.addEventListener('mouseleave', arrancar);
        caja.addEventListener('focusin', pausar);

        /* No rotar mientras la sección no está a la vista */
        if ('IntersectionObserver' in window) {
          new IntersectionObserver(function (entries) {
            entries[0].isIntersecting ? arrancar() : parar();
          }, { threshold: 0.25 }).observe(caja);
        } else {
          arrancar();
        }

        pintarPuntos();
      })(cajas[c]);
    }
  }

  function boot() {
    safe(initReveal, 'reveal');
    safe(initFaq, 'faq');
    safe(initScrollToBuy, 'scrollToBuy');
    safe(initSticky, 'sticky');
    safe(initVideo, 'video');
    safe(initCarrusel, 'carrusel');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
